module.exports = __webpack_public_path__ + "media/images/boxes/panel-ofert-c4f91270d5eb611aa8acf07261896280.png";